/* ============
 * Add multiple products modal
 * ============
 *
 * This is the component for creating batch log
 */
import productService from '../../services/product';
import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      products: [],
      optionsLoading: false,
      subTitle: '',
      submitLoading: false,
    };
  },
  props: {
    selectedProducts: {
      type: Array,
      required: true,
      default: () => [],
    },
    onSubmit: {
      type: Function,
      required: true,
      default: () => { },
    },
    type: {
      type: String,
      required: true,
      default: '',
    },
  },

  mounted() {
    this.products = JSON.parse(JSON.stringify(this.selectedProducts));
  },
  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
    }),

    proceed() {
      this.submitLoading = true;
      if (this.type === 'syncToWoo') {
        productService.bulkSyncToWoo(this.selectedProducts.map(item => item.id))
          .then(() => {
            this.submitLoading = false;
            this.$message({
              message: 'Selected product successfully Synced',
              type: 'success',
            });
            this.handleSubmit();
          }).catch(() => {
            this.submitLoading = false;
          });
        return;
      }
      productService.bulkUpdate({ product_ids: this.selectedProducts.map(item => item.id), type: this.type })
      .then(() => {
        this.submitLoading = false;
        this.$message({
          message: 'Selected product successfully update',
          type: 'success',
        });
        this.handleSubmit();
      });
    },

    handleSubmit() {
      this.closeModal();
      this.onSubmit();
    },

    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    //
  },
};



// WEBPACK FOOTER //
// ./src/app/components/bulkProcessProductModal/bulkProcessProductModal.js